import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export default function MetricCard({ title, value, icon, trend, trendValue, subtitle }) {
    return (
        <Card
            sx={{
                height: '100%',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: 'none',
                transition: 'all 0.2s',
                '&:hover': {
                    boxShadow: 2,
                    borderColor: 'primary.main',
                },
            }}
        >
            <CardContent sx={{ p: 3 }}>
                <Stack spacing={2}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                        <Typography variant="body2" color="text.secondary" fontWeight={500}>
                            {title}
                        </Typography>
                        <Box sx={{ color: 'action.active', opacity: 0.5 }}>{icon}</Box>
                    </Stack>
                    <Typography variant="h3" fontWeight={600} sx={{ color: 'text.primary' }}>
                        {value}
                    </Typography>
                    {subtitle ? (
                        <Typography variant="body2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    ) : null}
                    {trend ? (
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            {trend === 'up' ? (
                                <TrendingUpIcon sx={{ fontSize: 16, color: 'success.main' }} />
                            ) : (
                                <TrendingDownIcon sx={{ fontSize: 16, color: 'error.main' }} />
                            )}
                            <Typography
                                variant="caption"
                                sx={{
                                    color: trend === 'up' ? 'success.main' : 'error.main',
                                    fontWeight: 600,
                                }}
                            >
                                {trendValue}
                            </Typography>
                        </Stack>
                    ) : null}
                </Stack>
            </CardContent>
        </Card>
    );
}
